import VideoPlayer from "../components/VideoPlayer";
import ReadMorePartnerships from "../components/ReadMorePartnerships";

/**
 * Single Partnership Page
 */
const PagePartnership = ($) => {
	if ($("body").hasClass("page-template-partnerships")) {
		VideoPlayer($);
		ReadMorePartnerships($);
	}
};

export default PagePartnership;
